import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NotificationCategoryEnum, NotificationDto, NotificationTypeEnum} from "@esa/api";
import {NotificationService} from '../../services';

interface Tab {
  name: string;
  filter: () => void;
}

@Component({
  selector: 'notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss']
})
export class NotificationPanelComponent {

  isPanelActive: boolean = false;
  isUpdatingReadStatus: boolean = false;
  selectedTabName: string = "Recent";
  activeTab: Tab;
  notifications: NotificationDto[] = []
  filteredNotifications: NotificationDto[] = [];
  tabs: Tab[] = [
    { name: 'Recent', filter: this.filterRecent.bind(this) },
    { name: 'Working Groups', filter: this.filterWorkingGroups.bind(this) },
    { name: 'Cases', filter: this.filterCases.bind(this) }
  ];
  @Input() set openPanel(op: boolean) {
    this.isPanelActive = op;
  };
  @Input() set notificationData(nd: NotificationDto[]) {
    if(!this.isUpdatingReadStatus) {
      this.notifications = nd;
      this.filterRecent();
    } else {
      this.notifications = nd;
      this.filterRecent();
      this.selectTab(this.activeTab, this.selectedTabName);
    }
  };
  @Output() panelClosed = new EventEmitter<boolean>();

  constructor(private _notificationService: NotificationService) {}

  onPanelClosed(event: boolean) {
    this.openPanel = event;
    this.panelClosed.emit(false);
  }

  filterRecent(): void {
    this.filteredNotifications = this.notifications.filter(notification => {
      const notificationDate = new Date(notification.created);
      const now = new Date();
      const diffInHours = Math.abs(now.getTime() - notificationDate.getTime()) / 36e5;
      return diffInHours <= 48;
    });
  }

  filterWorkingGroups(): void {
    this.filteredNotifications = this.notifications.filter(notification =>
      notification.category === NotificationCategoryEnum.WORKING_GROUP);
  }

  filterCases(): void {
    this.filteredNotifications = this.notifications.filter(notification =>
      notification.category === NotificationCategoryEnum.CASE);
  }

  selectTab(tab: Tab, selectedTab: string): void {
    tab.filter();
    this.activeTab = tab;
    this.selectedTabName = selectedTab;
  }

  updateReadStatus(message: string, notificationType: NotificationTypeEnum, userId: string, id: string, notificationCategory: NotificationCategoryEnum, reference: string): void {
    this._notificationService.updateReadStatus(message, notificationType, userId, id, notificationCategory, reference);
    this.isUpdatingReadStatus = true;
  }

  viewNotification(notification: NotificationDto): void {
    this.isPanelActive = false;

    this._notificationService.viewNotification(notification);
    this._notificationService.updateReadStatus(notification.message, notification.notificationType, notification.userId, notification.id, notification.category, notification.reference);
  }
}
